import React from 'react';
import ToolsMenu from '@/components/tools/ToolsMenu';
import DataManagementDictionaryTools from './DataManagementDictionaryTools';

const DataManagementDictionaryToolsMenu = ({
  allowConversion,
  convert,
  dictionaryCode,
  dictionaryName,
  disableConvert,
  disableValidate,
  listItem,
  showReports,
  upward,
  validate,
}) => (
  <ToolsMenu listItem={listItem} upward={upward}>
    <DataManagementDictionaryTools
      allowConversion={allowConversion}
      convert={convert}
      dictionaryCode={dictionaryCode}
      dictionaryName={dictionaryName}
      disableConvert={disableConvert}
      disableValidate={disableValidate}
      showReports={showReports}
      validate={validate}
    />
  </ToolsMenu>
);

export default DataManagementDictionaryToolsMenu;
